import { Input, Directive, ElementRef, ViewChild, ChangeDetectorRef, HostBinding } from '@angular/core'
import { NgElement, WithProperties } from '@angular/elements'
import { SetItemElement } from '../set-item/set-item.component'

/**
 * @public
 */
export type SetElement = NgElement & WithProperties<SetComponent>

/**
 * @public
 */
@Directive()
export abstract class SetComponent {

  @ViewChild('itemSlot')
  protected _itemSlotRef: ElementRef<HTMLSlotElement>

  protected _activeItem: SetItemElement
  protected _items: SetItemElement[] = []

  @Input()
  @HostBinding()
  collapse = false

  constructor(protected _changeDetectorRef: ChangeDetectorRef) {}

  onSlottedContentChanged(): void {
    this._items = this._itemSlotRef
      .nativeElement
      ?.assignedElements()
      ?.filter(it => it.localName === 'gpei-set-item') as SetItemElement[]

    this.activateDefaultItem()

    this._changeDetectorRef.detectChanges()
  }

  get items(): SetItemElement[] {
    return this._items
  }

  activateDefaultItem(): void {
    if (this.items.length > 1) {
      let item = this.items.find(it => it.active)

      if (item) {
        this.activeItem = item
      }

      else {
        this.activeItem = this.items[0]
      }
    }
  }

  /**
   * Get the first child item that has the given value
   *
   * @param value  The value being searched for
   */
  getItemByValue(value: string): SetItemElement {
    return this.items.filter(item => item.value === value)[0] ?? null
  }

  /**
   * Set the active item. This will change the display and
   * will hide all other items other then the active item.
   *
   * @param item  The item that will be marked as active
   */
  set activeItem(value: SetItemElement) {
    if (this._activeItem) {
      this._activeItem.active = false
    }

    if (value) {
      value.active = true
    }

    this._activeItem = value
  }

  get activeItem(): SetItemElement {
    return this._activeItem
  }

}
